<h2 class="t-widgetTitle">{{ title }} ({{ bb.length }})</h2>

<div *ngFor="let box of bb" class="box-tile">
  <bb-card [box]="box" [doc]="doc" (onDelete)="deleteBox(doc, box)"> </bb-card>
</div>
